/**
 * Unified view types for consistent Table/Visual switching across the platform
 * Used by Collections, Trade Lists, and LGS components
 */

export type ViewName = "Table" | "Visual";
export type ViewIndex = 0 | 1;

export interface ViewOption {
  name: ViewName;
}

export const UNIFIED_VIEWS: ViewOption[] = [
  { name: "Table" },
  { name: "Visual" },
];

/**
 * Default view index (1 = Visual view).
 * Single source of truth for the pre-preference default — the cookie
 * fallbacks in utils/view-preference.ts and the Zustand store both use it.
 */
export const DEFAULT_VIEW_INDEX: ViewIndex = 1;

/**
 * Deck-specific view index supporting all 5 display modes
 */
export type DeckViewIndex = 0 | 1 | 2 | 3 | 4;
export const DEFAULT_DECK_VIEW_INDEX: DeckViewIndex = 0;
